export const changeTitle = (title) => {
   changeMetaTitle(title);

   return document.title = title;
}

export const changeMetaTitle = (title) => {
   const ogTitle = document.querySelector('meta[property="og:title"]');
   const twitterTitle = document.querySelector('meta[property="twitter:title"]');

   if(ogTitle) ogTitle.setAttribute("content", title);
   if(twitterTitle) twitterTitle.setAttribute("content", title);
}
